import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { ContextAuth } from "../../contexts/ContextAuth";
import { useHooksAuth } from "../../hooks";

export function CustomSidebar({ collapsed }) {
    const { auth } = useContext(ContextAuth);
    const { logout } = useHooksAuth();
    const [isSupervisor, setIsSupervisor] = useState(false);
    const [isAdministrator, setIsAdministrator] = useState(false);
    const [isSeller, setIsSeller] = useState(false);
    const [openMenus, setOpenMenus] = useState({
        logistics: true,
        finances: true,
        hrm: false,
        buys: false,
        dispatches: false,
        reports: false,
    });

    useEffect(() => {
        if (
            auth.data &&
            auth.data.code &&
            auth.data.code === "token_not_valid"
        ) {
            logout();
        } else {
            if (auth.data.groups.some((item) => item.name === "Administrativo"))
                setIsAdministrator(true);
            else if (auth.data.groups.some((item) => item.name === "Vendedor"))
                setIsSeller(true);
            else if (
                auth.data.groups.some((item) => item.name === "Supervisor")
            )
                setIsSupervisor(true);
        }
    }, []);

    const toggleMenu = (menu) => {
        setOpenMenus((prev) => ({
            ...prev,
            [menu]: !prev[menu],
        }));
    };

    return (
        <aside className={`app-sidebar ${collapsed ? "collapsed" : ""}`}>
            <div className="sidebar-brand">
                <img src="/dist/img/newlogo.png" alt="Logo" />
                {!collapsed && (
                    <span className="brand-name">DIST. "DELDIA"</span>
                )}
            </div>
            <nav className="sidebar-nav">
                {isAdministrator && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("logistics")}
                        >
                            <i className="fas fa-th"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    LOGÍSTICA
                                    <i
                                        className={`fas fa-chevron-${openMenus.logistics ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.logistics && (
                            <div className="submenu">
                                <Link
                                    to="/logistics/products"
                                    className="menu-item"
                                >
                                    <i className="fas fa-cube"></i>
                                    <span>Productos</span>
                                </Link>
                                <Link
                                    to="/logistics/product_brands"
                                    className="menu-item"
                                >
                                    <i className="fas fa-sitemap"></i>
                                    <span>Marcas y Unidades</span>
                                </Link>
                                <Link
                                    to="/logistics/warehouses"
                                    className="menu-item"
                                >
                                    <i className="fas fa-cubes"></i>
                                    <span>Almacenes</span>
                                </Link>
                                <Link
                                    to="/logistics/inventories"
                                    className="menu-item"
                                >
                                    <i className="fas fa-globe"></i>
                                    <span>Mov. Kardex</span>
                                </Link>
                                <Link
                                    to="/logistics/matrix"
                                    className="menu-item"
                                >
                                    <i className="fas fa-cube"></i>
                                    <span>Matriz de productos</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                {isAdministrator && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("finances")}
                        >
                            <i className="fas fa-copy"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    FINANZAS
                                    <i
                                        className={`fas fa-chevron-${openMenus.finances ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.finances && (
                            <div className="submenu">
                                <Link
                                    to="/accounting/accountReceive"
                                    className="menu-item"
                                >
                                    <i className="fas fa-file-invoice-dollar"></i>
                                    <span>Cuentas por cobrar</span>
                                </Link>
                                <Link
                                    to="/accounting/CollectionSheetPage"
                                    className="menu-item"
                                >
                                    <i className="fas fa-cube"></i>
                                    <span>Hoja de cobranza</span>
                                </Link>
                                <Link to="/accounting/daily_collection_page" className="menu-item">
                                <i className="fas fa-file-invoice-dollar"></i>
                                <span>Cobranza diaria por vendedor</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                {isAdministrator && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("hrm")}
                        >
                            <i className="fas fa-users-cog"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    RRHH
                                    <i
                                        className={`fas fa-chevron-${openMenus.hrm ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.hrm && (
                            <div className="submenu">
                                <Link to="/employees" className="menu-item">
                                    <i className="fas fa-user-astronaut"></i>
                                    <span>Empleados</span>
                                </Link>
                                <Link to="/subsidiaries" className="menu-item">
                                    <i className="fas fa-house-damage"></i>
                                    <span>Sucursal</span>
                                </Link>
                                <Link to="/gangs" className="menu-item">
                                    <i className="fas fa-id-card-alt"></i>
                                    <span>Rutas / Cuadrillas</span>
                                </Link>
                                {/* <Link to="/epps" className="menu-item">
                                    <i className="fas fa-user-lock"></i>
                                    <span>EPPS</span>
                                </Link> */}
                                <Link to="/schedules" className="menu-item">
                                    <i className="fas fa-clock"></i>
                                    <span>Horarios</span>
                                </Link>
                                <Link to="/roles" className="menu-item">
                                    <i className="fas fa-user-tag"></i>
                                    <span>Roles</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                {isAdministrator && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("buys")}
                        >
                            <i className="fas fa-shopping-cart"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    COMPRAS
                                    <i
                                        className={`fas fa-chevron-${openMenus.buys ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.buys && (
                            <div className="submenu">
                                <Link
                                    to="/buys/purchase_orders_issued"
                                    className="menu-item"
                                >
                                    <i className="fas fa-search"></i>
                                    <span>Busqueda de pedidos</span>
                                </Link>
                                <Link
                                    to="/buys/new_purchase_order"
                                    className="menu-item"
                                >
                                    <i className="fas fa-map"></i>
                                    <span>Registrar pedido</span>
                                </Link>
                                <Link
                                    to="/buys/purchases_issued"
                                    className="menu-item"
                                >
                                    <i className="fas fa-cart-arrow-down"></i>
                                    <span>Compras recibidas</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                {(isAdministrator || isSupervisor) && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("dispatches")}
                        >
                            <i className="fas fa-truck"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    VENTAS Y ABAST.
                                    <i
                                        className={`fas fa-chevron-${openMenus.dispatches ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.dispatches && (
                            <div className="submenu">
                                {isAdministrator && (
                                    <>
                                        <Link
                                            to="/dispatches/distributions"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-paper-plane"></i>
                                            <span>Ventas de reparto</span>
                                        </Link>
                                        <Link
                                            to="/dispatches/supplyings"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-share"></i>
                                            <span>Abastecimiento</span>
                                        </Link>
                                        <Link
                                            to="/dispatches/devolutions"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-reply"></i>
                                            <span>Devoluciones</span>
                                        </Link>
                                        <Link
                                            to="/dispatches/readjustments"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-screwdriver"></i>
                                            <span>Reajustes de almacen</span>
                                        </Link>
                                        <Link
                                            to="/dispatches/accumulative_dispatches"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-globe"></i>
                                            <span>Ventas Acumuladas</span>
                                        </Link>
                                        <Link
                                            to="/dispatches/map_clients"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-map-marked-alt"></i>
                                            <span>Ubicacion de clientes</span>
                                        </Link>
                                        {/* <Link
                                            to="/logistics/merchandises"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-cubes"></i>
                                            <span>
                                                Mercaderia por repartidor
                                            </span>
                                        </Link> */}
                                        <Link
                                            to="/dispatches/order_tray"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-screwdriver"></i>
                                            <span>Bandeja de pedidos</span>
                                        </Link>
                                        {/* <Link
                                            to="/dispatches/special_sales"
                                            className="menu-item"
                                        >
                                            <i className="fas fa-paper-plane"></i>
                                            <span>Ventas especiales</span>
                                        </Link> */}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {(isAdministrator || isSupervisor) && (
                    <div className="sidebar-menu">
                        <button
                            className="menu-item menu-item-header"
                            onClick={() => toggleMenu("reports")}
                        >
                            <i className="fas fa-chart-line"></i>
                            {!collapsed && (
                                <span className="menu-item-text">
                                    REPORTES
                                    <i
                                        className={`fas fa-chevron-${openMenus.reports ? "down" : "right"} menu-item-chevron`}
                                    ></i>
                                </span>
                            )}
                        </button>
                        {!collapsed && openMenus.reports && (
                            <div className="submenu">
                                <Link
                                    to="/dispatches/sales_statistics"
                                    className="menu-item"
                                >
                                    <i className="fas fa-chart-bar"></i>
                                    <span>Ventas por semana</span>
                                </Link>
                                <Link
                                    to="/dispatches/daily_route_graph_by_day"
                                    className="menu-item"
                                >
                                    <i className="fas fa-chart-pie"></i>
                                    <span>Ventas por ruta</span>
                                </Link>
                                <Link
                                    to="/dispatches/sold_product_graph_by_day"
                                    className="menu-item"
                                >
                                    <i className="fas fa-chart-area"></i>
                                    <span>Ventas de productos</span>
                                </Link>
                                <Link
                                    to="/dispatches/client_portfolios"
                                    className="menu-item"
                                >
                                    <i className="fas fa-user-tag"></i>
                                    <span>Cartera de clientes</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}
            </nav>
        </aside>
    );
}
